<template>
  <div class="bottom-top">
    <h4>
      <img src="../../../../assets/images/title.png">
      <span>说明</span>
    </h4>
    <div>1.统计频率：按月统计，每月6号更新上月数据</div>
    <div>2.{{roadName}}运营数据：每辆车每天在此分段{{roadName}}运营过则计1次，总运营车次/统计月总天数=日均运营车次；总运营里程/统计月总天数=日均运营里程</div>
    <div>3.{{roadName}}加能站流量数据：按月统计此分段{{roadName}}上的各品牌油站的停靠次数</div>
    <div>4.{{roadName}}加能站流量明细：站前流量为此站点前道路的途经车次数，站内停靠为此站点内的停靠车次数，站内停靠/站前流量=进站率</div>
  </div>
</template>

<script>
import nameMixin from './nameMixin'
export default {
  mixins: [nameMixin],
}
</script>
